import React, { useState } from "react";
import { Spinner } from "react-bootstrap";

const ImportPlans = () => {
  const [loading, setLoading] = useState(false);

  const filteredPlans = [
    {
      id: "1",
      name: "Learning Plans",
    },
    {
      id: "2",
      name: "Locations",
    },
    {
      id: "3",
      name: "Sessions",
    },
    {
      id: "4",
      name: "Sessions Details",
    },
    {
      id: "5",
      name: "Courses",
    },
    {
      id: "6",
      name: "Learning plan online courses",
    },
  ];

  return (
    <div
      style={{
        padding: "10px",
        backgroundColor: "white",
        borderRadius: "8px",
        maxHeight: "90vh",
        overflowY: "auto",
      }}
    >
      {loading ? (
        <div className="container p-3 mt-3">
          <div className="row">
            <h6 className="text-center color-grey pt-5">
              <Spinner animation="border" />
            </h6>
          </div>
        </div>
      ) : filteredPlans.length > 0 ? (
        <div>
          {filteredPlans.map((plan) => (
            <div key={plan.id} className="learning-plans-container">
              <div className="learning-plans">
                <div className="learning-plan-heading">{plan.name}</div>
              </div>
              <div className="select-learning-plan-btn">
                <button
                  onClick={() => ""}
                  className="button"
                  style={{ width: "150px" }}
                >
                  Import
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-learning-plans">No learning plans are available</div>
      )}
    </div>
  );
};

export default ImportPlans;
